import React from 'react'

import Modal  from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import style from "../../style.module";

export default class CustomerRacerTosLink extends React.Component {
    state = {
        showModal: false
    };

    showModal = (event) => {
        if (event) { event.preventDefault(); }

        this.setState({
            showModal: true
        });
    };

    closeModal = () => {
        this.setState({
            showModal: false
        });
    };

    render() {
        const tosText = {__html: I18n.t('cart_summary.accept_tos_html', { button_text: I18n.t('cart_summary.send_order')}) };
        const tosBody = {__html: I18n.t('tos_html')};

        return (
            <div>
                <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{I18n.t('tos')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div dangerouslySetInnerHTML={tosBody}/>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.closeModal}>{I18n.t('close')}</Button>
                    </Modal.Footer>
                </Modal>
                <div className={style.tos} onClick={this.showModal} dangerouslySetInnerHTML={tosText}/>
            </div>

        )
    }

}
